module.exports = __webpack_public_path__ + "static/help-aa1b40d6fe2eb20e87f2a07b0e55dabe.mp4";